import React from 'react';
import styles from './AboutUsValues.module.scss';

const stats = [
    { value: '100+', label: <>Students tutored through <a href="https://advprep.com" target="_blank" rel="noopener noreferrer" style={{ color: '#0257ef' }}>Advantage Prep</a></> },
    { value: '3+', label: 'Years of SAT tutoring operation' },
    { value: '150+', label: 'Average point improvement' },
    { value: '85%', label: 'Students achieved their target score' },
];

const AboutUsValues = () => {
    return (
        <section className={styles.section}>
            <div className={styles.contentWrapper}>
                <h2 className={styles.heading}>Backed by the <a href="https://advprep.com" target="_blank" rel="noopener noreferrer" style={{ color: '#0257ef' }}>Advantage Prep</a> Network</h2>
                <p className={styles.subheading}>
                    Prepal didn't come from a lab. It came from years of working directly
                    with students and families.
                </p>
                <div className={styles.statsGrid}>
                    {stats.map((stat, i) => (
                        <div key={i} className={styles.statCard}>
                            <span className={styles.statValue}>{stat.value}</span>
                            <span className={styles.statLabel}>{stat.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AboutUsValues;
